import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import { FONT_SIZE_CLASS_NAME } from '../constants/responsive-class-names';
import stripTextAutofillClasses from './strip-text-autofill-classes';

const SUBORDINATE_BREAKPOINTS = {
  [TABLET_BREAKPOINT]: [MOBILE_BREAKPOINT],
};

const stripAutofillAtBreakpoint = (currentClass, breakpoint, className = FONT_SIZE_CLASS_NAME) => {
  if (!breakpoint) {
    return stripTextAutofillClasses(currentClass, className);
  }

  const breakpoints = [breakpoint, ...(SUBORDINATE_BREAKPOINTS[breakpoint] || [])];

  return breakpoints.reduce(
    (classNameValue, breakpointName) =>
      stripTextAutofillClasses(classNameValue, className, breakpointName),
    currentClass
  );
};

export default stripAutofillAtBreakpoint;
